const specialProductVariants = window.ATB?.specialProductVariants || [];

const isSpecialProduct = (variantId) => {
  return specialProductVariants.includes(variantId);
};

function injectUidProperty(form) {
  const formData = new FormData(form);
  const properties = {};

  for (const [key, value] of formData.entries()) {
    const match = key.match(/^properties\[(.+)\]$/);

    if (match) {
      properties[match[1]] = value;
    }
  }

  const uid = window.ATB.buildUid(properties);

  form
    .querySelectorAll('input[name="properties[_uid]"]')
    .forEach((i) => i.remove());

  if (!uid) return;

  const input = document.createElement("input");
  input.type = "hidden";
  input.name = "properties[_uid]";
  input.value = uid;

  form.appendChild(input);
}

Handlebars.registerHelper("startsWith", function (str, prefix) {
  return (str || "").startsWith(prefix);
});

function buildItemData(t, r, settings) {
  const prices = window.ATB?.embroideryPrices || {};

  var addPrice = r.price;
  var propertiesStatus = false;

  if (r.properties) {
    if (r.properties.text && r.properties.Logo) {
      addPrice += prices.both;
      propertiesStatus = "both";
    } else if (r.properties.text) {
      addPrice += prices.text;
      propertiesStatus = "text";
    } else if (r.properties.logo) {
      addPrice += prices.logo;
      propertiesStatus = "logo";
    }

    if (r.properties.text2) {
      addPrice += prices.second_line;
    }

    if (r.properties.Retouche) {
      const alterations = r.properties.Retouche.split(",")
        .map((s) => s.trim())
        .filter(Boolean);

      alterations.forEach(function (name) {
        addPrice += prices.alterations?.[name] || 0;
      });
    }
  }

  var img = r.image
    ? r.image.replace(/(\.[^.]*)$/, "_200x$1").replace("http:", "")
    : "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";

  return {
    id: r.variant_id,
    line: t + 1,
    propertiesStatus,
    hasSecondLine: !!(r.properties && r.properties.text2),
    variantQty: r.quantity,
    url: r.url,
    img,
    name: r.product_title,
    variation: r.variant_title,
    properties: r.properties,
    itemAdd: r.quantity + 1,
    itemMinus: r.quantity - 1,
    itemQty: r.quantity,
    price: Shopify.formatMoney(addPrice, settings.moneyFormat),
    vendor: r.vendor,
    key: r.key,
    isAlteration: !!(r.properties && r.properties?._atb_role === "child"),
  };
}

function buildCartData(t, settings) {
  var parents = [];
  var alterations = [];

  $.each(t.items, function (index, item) {
    if (isSpecialProduct(item.variant_id)) return;
    const data = buildItemData(index, item, settings);
    if (item.properties && item.properties._atb_role === "child") {
      alterations.push(data);
    } else {
      parents.push(data);
    }
  });

  var items = [];
  parents.forEach(function (parent) {
    items.push(parent);

    const parentUid = parent.properties?._uid;

    alterations
      .filter((a) => {
        return parentUid && a.properties?._uid === parentUid;
      })
      .forEach((a) => items.push(a));
  });

  return {
    items,
    note: t.note,
    totalPrice: Shopify.formatMoney(t.total_price, settings.moneyFormat),
    freeShippingAmountRemaining: 150 - t.total_price / 100,
    freeShipping: t.total_price / 100 >= 150,
    cartProgressBarPercentage:
      t.total_price / 100 >= 150
        ? "100%"
        : `${(t.total_price / 100 / 150) * 100}%`,
  };
}

function attributeToString(t) {
  return (
    "string" != typeof t && "undefined" === (t += "") && (t = ""),
    jQuery.trim(t)
  );
}
("undefined" == typeof ShopifyAPI && (ShopifyAPI = {}),
  (ShopifyAPI.onCartUpdate = function (t) {}),
  (ShopifyAPI.updateCartNote = function (t, a) {
    var e = {
      type: "POST",
      url: "/cart/update.js",
      data: "note=" + attributeToString(t),
      dataType: "json",
      success: function (t) {
        "function" == typeof a ? a(t) : ShopifyAPI.onCartUpdate(t);
      },
      error: function (t, a) {
        ShopifyAPI.onError(t, a);
      },
    };
    jQuery.ajax(e);
  }),
  (ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
    var data = eval("(" + XMLHttpRequest.responseText + ")");
    data.message &&
      alert(data.message + "(" + data.status + "): " + data.description);
  }),
  (ShopifyAPI.addItemFromForm = function (t, a, e) {
    var r = "velaCartAdding";
    "fly" == window.ajaxcart_type && (r = "");
    var formData = new FormData(jQuery(t)[0]);
    var o = {
      type: "POST",
      url: "/cart/add.js?_easygift_form_payload=true",
      data: formData,
      dataType: "json",
      processData: false,
      contentType: false,
      beforeSend: function () {
        $("body").addClass(r);
      },
      success: function (e) {
        ($("body").removeClass(r),
          "modal" == window.ajaxcart_type &&
            (null != e.image
              ? $(".headerCartModal")
                  .find(".cartProductImage img")
                  .attr("src", e.image)
              : $(".headerCartModal")
                  .find(".cartProductImage img")
                  .attr("src", "//placehold.it/100x100"),
            $(".headerCartModal").find(".productTitle").html(e.title),
            $(".headerCartModal").addClass("active")),
          "function" == typeof a ? a(e, t) : ShopifyAPI.onItemAdded(e, t));
      },
      error: function (a, o) {
        ($("body").removeClass(r),
          "function" == typeof e ? e(t, a, o) : ShopifyAPI.onError(a, o));
      },
    };
    jQuery.ajax(o);
  }),
  (ShopifyAPI.getCart = function (t) {
    jQuery.getJSON("/cart.js", function (a, e) {
      "function" == typeof t ? t(a) : ShopifyAPI.onCartUpdate(a);
    });
  }));
var ajaxCart = (function (module, $) {
  "use strict";
  var init,
    loadCart,
    settings,
    isUpdating,
    $body,
    $formContainer,
    $addToCart,
    $cartCountSelector,
    $cartCostSelector,
    $cartContainer,
    $drawerContainer,
    updateCountPrice,
    formOverride,
    itemAddedCallback,
    itemErrorCallback,
    cartUpdateCallback,
    buildCart,
    cartCallback,
    adjustCart,
    adjustCartCallback,
    createQtySelectors,
    qtySelectors,
    validateQty;
  return (
    (init = function (t) {
      ((settings = {
        formSelector: 'form[action^="/cart/add"]',
        cartContainer: "#cartContainer",
        addToCartSelector: 'input[type="submit"]',
        cartCountSelector: null,
        cartCostSelector: null,
        moneyFormat: window.money,
        disableAjaxCart: !1,
        enableQtySelectors: !0,
      }),
        $.extend(settings, t),
        ($formContainer = $(settings.formSelector)),
        ($cartContainer = $(settings.cartContainer)),
        ($addToCart = $formContainer.find(settings.addToCartSelector)),
        ($cartCountSelector = $(settings.cartCountSelector)),
        ($cartCostSelector = $(settings.cartCostSelector)),
        ($body = $("body")),
        (isUpdating = !1),
        settings.enableQtySelectors && qtySelectors(),
        !settings.disableAjaxCart && $addToCart.length && formOverride(),
        adjustCart());
    }),
    (loadCart = function () {
      ($body.addClass("ajaxcartIsLoading"),
        ShopifyAPI.getCart(cartUpdateCallback));
    }),
    (updateCountPrice = function (t) {
      var Embodiary_Item = $.grep(t.items, function (n) {
        return isSpecialProduct(n.variant_id);
      });
      var Embodiary_Qty = 0;
      $.each(Embodiary_Item, function (key, value) {
        Embodiary_Qty = Embodiary_Qty + value.quantity;
      });
      ($cartCountSelector &&
        ($cartCountSelector
          .html(t.item_count - Embodiary_Qty)
          .removeClass("hidden-count"),
        0 === t.item_count && $cartCountSelector.addClass("hidden-count")),
        $(".jsDrawerOpenRight #CartCount").text(t.item_count - Embodiary_Qty));
      $cartCostSelector &&
        $cartCostSelector.html(
          Shopify.formatMoney(t.total_price, settings.moneyFormat),
        );
    }),
    (formOverride = function () {
      "page" != window.ajaxcart_type &&
        $formContainer.on("submit", function (t) {
          t.preventDefault();
          $addToCart.removeClass("is-added").addClass("is-adding");
          $(".qtyError").remove();

          t.target
            .querySelectorAll('input[name^="properties[_alteration_"]')
            .forEach((el) => el.remove());

          t.target
            .querySelectorAll('input[name^="properties[Retouche]"]')
            .forEach((el) => el.remove());

          const pending = window.ATB?._pendingAlterations || [];

          pending.forEach((variantId) => {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = `properties[_alteration_${variantId}]`;
            input.value = "true";
            t.target.appendChild(input);
          });

          const titles = pending
            .map((id) => window.ATB?.alterationTitles?.[id])
            .filter(Boolean);

          if (titles.length) {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = "properties[Retouche]";
            input.value = titles.join(", ");
            t.target.appendChild(input);
          }

          injectUidProperty(t.target);

          ShopifyAPI.addItemFromForm(
            t.target,
            itemAddedCallback,
            itemErrorCallback,
          );

          $formContainer.hasClass("formQuickview") &&
            ($("#velaQuickView").fadeOut(500),
            $(".jsQuickview").html(""),
            $(".jsQuickview").fadeOut(500));
        });
    }),
    (itemAddedCallback = function (item) {
      $addToCart.removeClass("is-adding").addClass("is-added");

      const pending = window.ATB?._pendingAlterations || [];
      console.log(item.properties);

      if (pending.length) {
        Promise.all(
          pending.map((variantId) =>
            window.ATB.addAlteration(
              variantId,
              item.properties._uid,
              item.quantity,
            ),
          ),
        ).finally(function () {
          ShopifyAPI.getCart(cartUpdateCallback);
        });
      } else {
        ShopifyAPI.getCart(cartUpdateCallback);
      }
    }),
    (itemErrorCallback = function (form, XMLHttpRequest, textStatus) {
      var data = eval("(" + XMLHttpRequest.responseText + ")");
      ($addToCart.removeClass("is-adding is-added"),
        data.message &&
          422 == data.status &&
          $(form).after(
            '<div class="alert alert-danger qtyError">' +
              data.description +
              "</div>",
          ));
    }),
    (cartUpdateCallback = function (t) {
      (updateCountPrice(t), buildCart(t));
    }),
    (buildCart = function (t) {
      $cartContainer.empty();

      var isModal = "modal" == window.ajaxcart_type;
      var emptyClass = isModal ? "headerCartEmpty" : "drawerCartEmpty";
      var templateId = isModal ? "#headerCartTemplate" : "#CartTemplate";

      if (0 === t.item_count) {
        $cartContainer.append(
          `<div class="${emptyClass}">${window.cart_empty}</div>`,
        );
        return void cartCallback(t);
      }

      var template = Handlebars.compile($(templateId).html());
      var data = buildCartData(t, settings);
      $cartContainer.append(template(data));
      cartCallback(t);
    }),
    (cartCallback = function (t) {
      ($body.removeClass("drawerIsLoading"),
        $body.trigger("ajaxCart.afterCartLoad", t),
        window.Shopify &&
          Shopify.StorefrontExpressButtons &&
          Shopify.StorefrontExpressButtons.initialize());
    }),
    (adjustCart = function () {
      const embroideryRules = {
        text: (i) => !!(i.properties?.text && !i.properties?.Logo),
        logo: (i) => !!i.properties?.logo,
        both: (i) => !!(i.properties?.text && i.properties?.Logo),
      };

      function computeUpdates(cart, itemKey, newQuantity) {
        const updates = {};
        const item = cart.items.find((i) => i.key === itemKey);
        if (!item) return updates;

        updates[itemKey] = newQuantity;

        const itemUid = item.properties?._uid;
        const isChild = item.properties?._atb_role === "child";

        if (itemUid && !isChild) {
          cart.items.forEach(function (child) {
            if (child.key === item.key) return;
            if (child.properties?._uid === itemUid) {
              updates[child.key] = newQuantity;
            }
          });
        }

        // Auto-clean orphelins
        cart.items.forEach(function (child) {
          if (child.properties?._atb_role !== "child") return;
          const childUid = child.properties?._uid;
          if (!childUid || updates[child.key] !== undefined) return;
          const hasParent = cart.items.some(
            (p) =>
              p.key !== child.key &&
              p.properties?._atb_role !== "child" &&
              p.properties?._uid === childUid,
          );
          if (!hasParent) updates[child.key] = 0;
        });

        return updates;
      }
      function applyUpdates(updates) {
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates }),
        }).then((r) => r.json());
      }

      let updateQueue = Promise.resolve();

      function updateItem(itemKey, newQuantity) {
        isUpdating = true;
        updateQueue = updateQueue
          .then(function () {
            return fetch("/cart.js")
              .then((r) => r.json())
              .then(function (cart) {
                const updates = computeUpdates(cart, itemKey, newQuantity);
                return applyUpdates(updates);
              });
          })
          .then(function () {
            isUpdating = false;
            ShopifyAPI.getCart(cartUpdateCallback);
          })
          .catch(function () {
            isUpdating = false;
            ShopifyAPI.getCart(cartUpdateCallback);
          });
        return updateQueue;
      }
      ($body.on("click", ".qtyAdjust", function () {
        var a = $(this),
          line = a.data("line"),
          r = a.siblings(".qtyNum"),
          o = parseInt(r.val().replace(/\D/g, ""));
        o = validateQty(o);
        a.hasClass("velaQtyPlus") ? (o += 1) : (o -= 1) <= 0 && (o = 0);
        r.val(o);

        if (line) {
          var itemKey = $('.ajaxCartRow[data-line="' + line + '"]').attr(
            "data-key",
          );
          if (!itemKey) return;
          clearTimeout(a.data("debounce"));
          a.data(
            "debounce",
            setTimeout(function () {
              updateItem(itemKey, o);
            }, 600),
          );
        }
      }),
        $body.on("change", ".qtyNum", function () {
          if (isUpdating) return;
          var a = $(this),
            line = a.data("line"),
            r = parseInt(a.val().replace(/\D/g, ""));
          r = validateQty(r);
          if (!line) return;
          var itemKey = $('.ajaxCartRow[data-line="' + line + '"]').attr(
            "data-key",
          );
          if (itemKey) updateItem(itemKey, r);
        }),
        $body.on("submit", "form.ajaxcart", function (evt) {
          var submitter = evt.originalEvent?.submitter;
          if (isUpdating && submitter?.name !== "checkout") {
            evt.preventDefault();
          }
        }),
        $body.on("focus", ".qtyAdjust", function () {
          var t = $(this);
          setTimeout(function () {
            t.select();
          }, 50);
        }),
        $body.on("change", 'textarea[name="note"]', function () {
          var t = $(this).val();
          ShopifyAPI.updateCartNote(t, function (t) {});
        }));

      document.addEventListener("click", function (e) {
        const btn = e.target.closest(".cartRemove");
        if (!btn) return;

        const itemKey = btn.closest(".ajaxCartRow")?.dataset.key;
        if (!itemKey) return;

        fetch("/cart.js")
          .then((r) => r.json())
          .then(function (cart) {
            const item = cart.items.find((i) => i.key === itemKey);
            if (!item) return;

            const isAlteration = item.properties?._atb_role === "child";
            const updates = computeUpdates(cart, itemKey, 0);

            applyUpdates(updates).then(function () {
              if (!isAlteration) {
                ShopifyAPI.getCart(cartUpdateCallback);
                return;
              }

              fetch("/cart.js")
                .then((r) => r.json())
                .then(function (updatedCart) {
                  const parent = updatedCart.items.find(
                    (i) =>
                      i.properties._uid === item.properties._uid &&
                      i.properties.atb_role !== "child",
                  );
                  if (!parent) {
                    ShopifyAPI.getCart(cartUpdateCallback);
                    return;
                  }

                  const mergeable = updatedCart.items.find(
                    (i) =>
                      i.variant_id === parent.variant_id &&
                      i.key !== parent.key &&
                      (!i.properties ||
                        !Object.keys(i.properties).some((k) =>
                          k.startsWith("_alteration_"),
                        )),
                  );

                  if (!mergeable) {
                    ShopifyAPI.getCart(cartUpdateCallback);
                    return;
                  }

                  applyUpdates({
                    [mergeable.key]: mergeable.quantity + parent.quantity,
                    [parent.key]: 0,
                  }).then(() => ShopifyAPI.getCart(cartUpdateCallback));
                });
            });
          });
      });
    }),
    (adjustCartCallback = function (t) {
      ((isUpdating = !1),
        updateCountPrice(t),
        setTimeout(function () {
          ShopifyAPI.getCart(buildCart);
        }, 150));
    }),
    (createQtySelectors = function () {
      $('input[type="number"]', $cartContainer).length &&
        $('input[type="number"]', $cartContainer).each(function () {
          var t = $(this),
            a = t.val(),
            e = a + 1,
            r = a - 1,
            o = a,
            i = $("#velaAjaxQty").html(),
            n = Handlebars.compile(i),
            d = { id: t.data("id"), itemQty: o, itemAdd: e, itemMinus: r };
          t.after(n(d)).remove();
        });
    }),
    (qtySelectors = function () {
      var t = $('input[type="number"]');
      t.length &&
        (t.each(function () {
          var t = $(this),
            a = t.val(),
            e = t.attr("name"),
            r = t.attr("id"),
            o = a + 1,
            i = a - 1,
            n = a,
            d = $("#velaJsQty").html(),
            c = Handlebars.compile(d),
            s = {
              id: t.data("id"),
              itemQty: n,
              itemAdd: o,
              itemMinus: i,
              inputName: e,
              inputId: r,
            };
          t.after(c(s)).remove();
        }),
        $("body").on("click", ".velaQtyAdjust", function () {
          var t = $(this),
            a = (t.data("id"), t.siblings(".velaQtyNum")),
            e = parseInt(a.val().replace(/\D/g, ""));
          e = validateQty(e);
          (t.hasClass("velaQtyPlus") ? (e += 1) : (e -= 1) <= 1 && (e = 1),
            a.val(e));
        }));
    }),
    (validateQty = function (t) {
      return ((parseFloat(t) != parseInt(t) || isNaN(t)) && (t = 1), t);
    }),
    (module = { init: init, load: loadCart }),
    module
  );
})(ajaxCart || {}, jQuery);
$(document).ready(function () {
  ajaxCart.init({
    formSelector: ".formAddToCart",
    cartContainer: "#cartContainer",
    addToCartSelector: ".btnAddToCart",
    cartCountSelector: "#CartCount",
    cartCostSelector: "#CartCost",
    moneyFormat: window.money,
  });
});
